import type { Theme } from "@mui/system";
import type { ComicDrawerProps } from "@vapor/react-contrib-tax-compliance/ComicDrawer/ComicDrawer";
import { ArrowLeft } from "@vapor/react-icons";
import { IconButton, useMediaQuery } from "@vapor/react-material";
import type { Dispatch, SetStateAction } from "react";
import { useMemo } from "react";
import type { GovernmentAgencyType } from "../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { TaxSubmissionOutcomePreview } from "../components/tax-submission-outcome-preview/TaxSubmissionOutcomePreview";
import type { DetailDrawerParams } from "./useDetailDrawer";

export interface OutcomePreviewDrawerParams {
    availableOutcomeTypes: string[];
    governmentAgencyType: GovernmentAgencyType;
    taxSubmissionId: string;
    selectedOutcomeType: string;
    taxPayer?: string;
}

export const useOutcomePreviewDrawer = (
    params: OutcomePreviewDrawerParams | undefined,
    setParams: Dispatch<SetStateAction<OutcomePreviewDrawerParams | undefined>>,
    setSelectedTaxSubmission: Dispatch<
        SetStateAction<DetailDrawerParams | undefined>
    >,
): ComicDrawerProps | undefined => {
    const isXlScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.up(theme.breakpoints.values.xl),
    );

    return useMemo(() => {
        if (!params) return undefined;

        return {
            content: (
                <TaxSubmissionOutcomePreview
                    {...params}
                    onChangeOutcomeType={(outcomeType) => {
                        setParams((prev) =>
                            prev
                                ? { ...prev, selectedOutcomeType: outcomeType }
                                : prev,
                        );
                    }}
                />
            ),
            headerLeft: [
                <IconButton
                    onClick={() => setParams(undefined)}
                    sx={{ padding: 0 }}
                >
                    <ArrowLeft color="interactive" />
                </IconButton>,
            ],
            headerTitle: params.selectedOutcomeType,
            onClickCloseButton: () => {
                setParams(undefined);
                setSelectedTaxSubmission(undefined);
            },
            open: true,
            width: isXlScreen ? "45%" : "65%",
        };
    }, [params, setParams, setSelectedTaxSubmission, isXlScreen]);
};
